export function approach(current: number, target: number, dtSeconds: number, rate: number): number {
  return target + (current - target) * Math.exp(-rate * dtSeconds);
}

/**
 * OrbitControls damping factor for a frame of dtSeconds. The controls keep 1 - factor
 * of the remaining motion per frame; this keeps (1 - perFrameAt60) per 60th of a
 * second instead, so a pan or drag glides for the same time at any frame rate.
 */
export function dampingFor(perFrameAt60: number, dtSeconds: number): number {
  return 1 - (1 - perFrameAt60) ** (dtSeconds * 60);
}

export function smoothstep(t: number): number {
  const x = Math.min(Math.max(t, 0), 1);
  return x * x * (3 - 2 * x);
}

export function focusDistanceFor(radiusScene: number): number {
  return Math.max(6 * radiusScene, 1e-3);
}
